import React from 'react'
import proimage from "../../Assets/images/pro-img-2.png";
import { LanguageConstants } from '../../constants/LanguageConstants';


function About() {
  return (
    <>
  <section className="about-us-sec">
    <div className="container">
      <div className="about-us-row">
        <div className="about-img">
          <img src={proimage}/>
        </div>
        <div className="about-sec-rght">
          <h2 className="com-heading">{LanguageConstants?.ABOUTUS}</h2>
          <p className="about-para">Lorem Ipsum&nbsp;is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy Lorem Ipsum&nbsp;is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy </p>
          <p className="about-para">Lorem Ipsum&nbsp;is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.</p>
          <a className="more-btn" href="#">{LanguageConstants?.MORE} <i className="icon-arrow-up-right" /></a>
        </div>
      </div>
    </div>
  </section>
    </>
  )
}

export default About